const styles = {
  container: {
    height: '80vh',
  },
};

export default styles;
